import {
  descriptionUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import omit from 'platform/utilities/data/omit';
import {
  paymentInformationReviewTitle,
  PaymentInformationReviewNote,
} from '../../components/additionalInformation/PaymentInformationReview';
import DirectDepositField, {
  hasEnteredBankAccount,
} from '../../components/additionalInformation/DirectDepositField';
import DirectDepositViewField from '../../components/additionalInformation/DirectDepositViewField';
import DirectDepositPage, {
  DirectDepositPageReview,
} from '../../components/additionalInformation/DirectDepositPage';
import ConfirmationPaymentInformation from '../../components/confirmationFields/ConfirmationPaymentInformation';
import paymentInformation from './paymentInformation';

const directDepositSchema = paymentInformation.schema.properties.directDeposit;

// A prefilled account is displayed from `view:prefilledBankAccount`, so an empty
// `directDeposit` is valid. Once the veteran enters anything, every bank field is
// required so we never submit a partial account.
export const updateBankAccountSchema = (formData, schema) => {
  const { directDeposit, 'view:prefilledBankAccount': prefilledBankAccount } =
    formData ?? {};
  const required =
    prefilledBankAccount && !hasEnteredBankAccount(directDeposit)
      ? []
      : directDepositSchema.required;

  return { ...schema, required };
};

// With a prefilled account and nothing entered, drop an empty/blank
// account fields so a partial account is never submitted. `hasNoAccount` lives
// in the same object and drives page routing, so it must be preserved.
export const updateFormData = (_oldData, newData) => {
  const { directDeposit, 'view:prefilledBankAccount': prefilled } =
    newData ?? {};
  const hasBlankAccountKeys =
    !!directDeposit &&
    Object.keys(directDeposit).some(key => key !== 'hasNoAccount');
  if (
    prefilled &&
    hasBlankAccountKeys &&
    !hasEnteredBankAccount(directDeposit)
  ) {
    return {
      ...newData,
      directDeposit: omit(
        Object.keys(directDeposit).filter(key => key !== 'hasNoAccount'),
        directDeposit,
      ),
    };
  }
  return newData;
};

export default {
  CustomPage: DirectDepositPage,
  CustomPageReview: DirectDepositPageReview,
  uiSchema: {
    'ui:confirmationField': ConfirmationPaymentInformation,
    ...titleUI(paymentInformationReviewTitle),
    directDeposit: {
      ...paymentInformation.uiSchema.directDeposit,
      'ui:title': 'Set up your direct deposit',
      'ui:field': DirectDepositField,
      'ui:options': {
        ...paymentInformation.uiSchema.directDeposit['ui:options'],
        hideLabelText: true,
        showFieldLabel: false,
        viewComponent: DirectDepositViewField,
        volatileData: true,
        updateSchema: updateBankAccountSchema,
      },
    },
    'view:paymentInformationReviewNote': {
      ...descriptionUI(PaymentInformationReviewNote),
    },
  },
  schema: {
    type: 'object',
    properties: {
      directDeposit: directDepositSchema,
      'view:paymentInformationReviewNote': {
        type: 'object',
        properties: {},
      },
    },
  },
};
